module.exports = __webpack_public_path__ + "img/2x.fef7a19.jpg";